import { VMOM1125CollGroupId } from "respondent_config_generator/src/projects/VMOM-1125";
import { PlatformInstructionsKey } from "../../LandingPage/Components/Steps/LoginAndCompletionCode";
import { LandingPageConfigBuilder } from "../../LandingPage/landingPageConfigBuilder";
import { CAIParams } from "../../queryParams";
import { setCurrentLang } from "../../i18n";
import { AppLanguage, getLanguageStrings } from "internationalisation";

const getPlatform = (groupId: VMOM1125CollGroupId): PlatformInstructionsKey => {
	switch (groupId) {
		case "VMOM-458-1125-AU-FACEBOOK":
			return "facebook";
		case "VMOM-459-1125-AU-YOUTUBE":
			return "youtube";
		default:
			assertNever(groupId);
	}
}

export const configureVMOM1125Page = (
	landingPageBuilder: LandingPageConfigBuilder,
	params: CAIParams<VMOM1125CollGroupId>
) => {
	setCurrentLang(AppLanguage.en);

	landingPageBuilder.setSteps(
		LandingPageConfigBuilder.getStandardViewingSurveySteps(
			getPlatform(params.G)
		)
	);

	landingPageBuilder.setPageTitle(
		getLanguageStrings(AppLanguage.en).LandingPage.Title
	);
}